import { PermissionThreeKeys } from '@teinor/erp/permissions'
import { OrderData } from '../../../../../../../../specificComponents/inputTableLayouts/order/OrderLayout/types'
import useEditDeleteModal from '../../../../../../../../utils/hooks/useEditDeleteModal'
import PermissionChecker from '../../../../../../../../baseComponents/PermissionChecker'
import { TwinIconToolTip } from '../../../../../../../../baseComponents/TwinIcon'
import { getUserPermissions } from '../../../../../../../../utils/reducers/getters'
import { faCopy } from '@fortawesome/pro-light-svg-icons'
import ModalBuyDeliveryNoteDuplicate from './ModalBuyDeliveryNoteDuplicate'

interface BuyDeliveryNoteDuplicateButtonProps {
    allRowData: OrderData
    permissionTy: PermissionThreeKeys
    title: string
    id: string
    children?: React.ReactNode
}

export const BuyDeliveryNoteDuplicateButton: React.FC<BuyDeliveryNoteDuplicateButtonProps> = ({ allRowData, permissionTy, title, id, children }) => {
    const { openModal, setOpenModal } = useEditDeleteModal()
    return (
        <PermissionChecker permission='create' userPermissions={getUserPermissions(permissionTy)}>
            <div onClick={() => setOpenModal({ type: 'create', allRowData })}>
                {children ?? <TwinIconToolTip classNameIcon='hover:text-green-43 regular22' message={title} icon={faCopy} id={id} />}
            </div>
            {openModal?.type === 'create' ? <ModalBuyDeliveryNoteDuplicate setOpened={() => setOpenModal({ type: 'delete', allRowData })} allRowData={allRowData} onSubmit={() => { }} /> : null}
        </PermissionChecker>
    )
}